import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as FavoritesUpdatedEvent from '@ori-events/favorites-updated';
import * as RequestFavoritesEvent from '@ori-events/request-favorites';
import * as ToggleFavoriteEvent from '@ori-events/toggle-favorite';
import { useCallback, useEffect, useState } from 'react';
import { HeartIcon } from "./HeartIcon";
import { HeartsAnimation } from "../HeartsAnimation";
import { jsx as _jsx } from "react/jsx-runtime";
var renderHeart = function renderHeart(isInFavorites, shouldAnimationRun, onClick) {
  return /*#__PURE__*/_jsx(HeartsAnimation, {
    state: isInFavorites,
    shouldAnimationRun: shouldAnimationRun,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(HeartIcon, {
      isFavorite: isInFavorites
    })
  });
};
export var FavoritesHeart = function FavoritesHeart(_ref) {
  var code = _ref.code,
    isFavorite = _ref.isFavorite,
    placement = _ref.placement,
    position = _ref.position,
    render = _ref.render,
    shades = _ref.shades;
  var _useState = useState(isFavorite !== null && isFavorite !== void 0 ? isFavorite : false),
    _useState2 = _slicedToArray(_useState, 2),
    isInFavorites = _useState2[0],
    setIsInFavorites = _useState2[1];
  var shadesCodes = shades === null || shades === void 0 ? void 0 : shades.map(function (shade) {
    return shade.productCode;
  });
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldAnimationRun = _useState4[0],
    setShouldAnimationRun = _useState4[1];
  var toggleFavorite = useCallback(function () {
    window.dispatchEvent(new CustomEvent(ToggleFavoriteEvent.Name, {
      detail: {
        code: code,
        placement: placement,
        position: position,
        requestedState: !isInFavorites
      }
    }));
  }, [code, isInFavorites, placement, position]);
  var handleClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (!isInFavorites) {
      setShouldAnimationRun(true);
    }
    toggleFavorite();
  }, [isInFavorites, toggleFavorite]);
  useEffect(function () {
    if (!code) {
      return undefined;
    }
    var onFavoriteUpdate = function onFavoriteUpdate(_ref2) {
      var favorites = _ref2.detail.favorites;
      var codes = new Set([code].concat(_toConsumableArray(shadesCodes !== null && shadesCodes !== void 0 ? shadesCodes : [])));
      var isProductInFavorites = favorites.some(function (productCode) {
        return codes.has(productCode);
      });
      setIsInFavorites(isProductInFavorites);
    };
    setShouldAnimationRun(false);
    window.addEventListener(FavoritesUpdatedEvent.Name, onFavoriteUpdate);
    window.dispatchEvent(new CustomEvent(RequestFavoritesEvent.Name));
    return function () {
      return window.removeEventListener(FavoritesUpdatedEvent.Name, onFavoriteUpdate);
    };
  }, [code, shadesCodes]);
  useEffect(function () {
    var providerExists = Boolean(document.querySelector('#favorites-provider-config'));
    if (providerExists) {
      window.dispatchEvent(new CustomEvent(RequestFavoritesEvent.Name));
    }
  }, []);
  var rendered = render === null || render === void 0 ? void 0 : render(renderHeart(isInFavorites, shouldAnimationRun), handleClick);
  return rendered !== null && rendered !== void 0 ? rendered : renderHeart(isInFavorites, shouldAnimationRun, handleClick);
};
//# sourceMappingURL=FavoritesHeart.js.map